// Produits proposés en fertilisation (formulaire d'apport et fiche ferti)

// Unités de la liste, dont celles des doses E-Phy (L/t, kg/t…) ; celle d'un produit choisi s'y ajoute si besoin
export const UNITS = ["kg/ha", "T/ha", "L/ha", "g/ha", "mL/ha", "m3/ha", "unite/ha", "mL/L", "mL/hL", "L/hL", "g/hL", "L/t", "kg/t", "L/q", "kg/m3"];
export const isEphy = (p) => String(p?.amm || "").startsWith("AMM MFSC");

/** Produits du formulaire : génériques Véyèr CIEL d'abord, puis le catalogue E-Phy (MFSC) de la même catégorie. */
export function fertiProducts(refData, category) {
  const generics = (refData?.amendements || []).filter(a => a.category === category);
  const ephy = (refData?.biostimulants || []).filter(p => isEphy(p) && p.category === category);
  return [...generics, ...ephy];
}

/** Lignes du sélecteur : « mes produits » en tête, puis le catalogue ; « Autre » en dernier. */
export function productItems(products) {
  return [
    ...products.map(p => p.mine
      ? { value: p.name, label: p.name, sublabel: ["Mon produit", p.formule].filter(Boolean).join(" · ") }
      : isEphy(p)
      // Formule tirée de la composition E-Phy (« 8-12-18 + MgO 2 % + B ») quand elle existe
      ? { value: p.name, label: p.name, sublabel: [p.formule, p.amm].filter(Boolean).join(" · ").slice(0, 80) }
      : { value: p.name, label: p.name, sublabel: [p.formule || "Générique", p.info].filter(Boolean).join(" · ").slice(0, 80) }),
    { value: "Autre", label: "Autre (personnalise)" },
  ];
}
